import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {animate, style, transition, trigger} from "@angular/animations";

import {LIST_TYPE, SearchParam} from '../../defines/client.const';
import {BookmarkInfo, TotalService} from '../../services/total/total.service';

@Component({
  selector: 'app-bookmark-popup',
  templateUrl: './bookmark-popup.component.html',
  styleUrls: ['./bookmark-popup.component.scss'],
  animations: [
    trigger('BookmarkInOut', [
      transition(':enter', [
        style({transform: 'translateY(100%)'}),
        animate('150ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({transform: 'translateY(50%)'}))
      ])
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookmarkPopupComponent implements OnInit {
  @Output() closePopup: EventEmitter<any>;

  public show = false;

  bmInfo: BookmarkInfo = null;

  constructor(
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private totalSvc: TotalService,
  ) {
    this.closePopup = new EventEmitter<any>();

    totalSvc.GetBookmarkInfo().subscribe(
      data => {
        this.bmInfo = data;

        this.cdRef.detectChanges();
      },
      err => console.error(err)
    );
  }

  ngOnInit(): void {
    this.show = true;
  }

  public onClose(): void {
    this.closePopup.emit();
  }

  public goWordBookmark(): void {
    const queryParams = {l: LIST_TYPE.BOOKMARK};
    this.router.navigate(['/word'], {queryParams}).then();
    this.onClose();
  }

  public goSajaseungeoBookmark(): void {
    const queryParams = {l: LIST_TYPE.BOOKMARK};
    this.router.navigate(['/sajaseungeo'], {queryParams}).then();
    this.onClose();
  }

  public goSaseungBookmark(): void {
    const queryParams: SearchParam = {
      l: LIST_TYPE.BOOKMARK,
    };
    this.router.navigate(['/saseung'], {queryParams}).then();
    this.onClose();
  }

  public goVideoBookmark(): void {
    const queryParams = {l: LIST_TYPE.BOOKMARK};
    this.router.navigate(['/movie-search'], {queryParams}).then();
    this.onClose();
  }

  public goProverbBookmark(): void {
    const queryParams: SearchParam = {
      l: LIST_TYPE.BOOKMARK,
    };
    this.router.navigate(['/proverb'], {queryParams}).then();
    this.onClose();
  }

  public goDialectBookmark(): void {
    const queryParams = {l: LIST_TYPE.BOOKMARK};
    this.router.navigate(['/dialect'], {queryParams}).then();
    this.onClose();
  }
}
